import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import classes from './CallDuration.module.scss';

class CallDuration extends Component {
  constructor(props) {
    super(props);

    const intervalId = setInterval(this.timer.bind(this), 1000);
    this.state = {
      duration: 0,
      intervalId
    };
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  getDuration() {
    const seconds = Math.round((Date.now() - this.props.startTime) / 1000);
    const minutes = parseInt(seconds / 60, 10);
    const hours = parseInt(seconds / (60 * 60), 10);

    const strHour = String(hours);
    const strMin = String(`00${minutes % 60}`).slice(-2);
    const strSec = String(`00${seconds % 60}`).slice(-2);
    if (hours) {
      return `${strHour}:${strMin}:${strSec}`;
    }
    return `${strMin}:${strSec}`;
  }

  timer() {
    this.setState({
      duration: this.state.duration + 1
    });
  }

  render() {
    return (
      <div className={classes.duration}>
        <span>{this.getDuration()}</span>
      </div>
    );
  }
}

CallDuration.propTypes = {
  startTime: PT.number
};

CallDuration.defaultProps = {
  startTime: 0
};

export default CallDuration;
